import * as React from 'react';
import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';
import { compose } from 'redux';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';
import DocumentViewer from 'af-components/DocumentViewer';
import LoadingIndicator from 'af-components/LoadingIndicator';

import * as AttachmentActions from 'af-actions/attachment';

import styles from './styles.module.scss';

interface OwnProps {
	attachmentId: Nullable<number>;
	showModal: boolean;
	closeModal: () => void;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const DocumentPreviewModal = React.memo((props: Props) => {
	const { attachmentId, showModal, closeModal, downloadAttachmentForPreview } = props;

	const [data, setData] = React.useState<Nullable<ArrayBuffer>>(null);

	React.useEffect(() => {
		const initialize = async () => {
			if (showModal && attachmentId) {
				const _data = await downloadAttachmentForPreview(attachmentId);
				setData(_data.data);
			}
		};
		initialize();

		return () => {
			setData(null);
		};
	}, [attachmentId, downloadAttachmentForPreview, showModal]);

	return (
		<>
			<CustomModal
				className={styles.modal}
				closeModal={closeModal}
				modalStyle="info"
				showModal={showModal}
				size="xl"
			>
				<CustomModal.Header className={styles.bigHeader}>
					<span>PDF PREVIEW</span>
				</CustomModal.Header>
				<CustomModal.Body className={styles.body}>
					{!data
						?
						<LoadingIndicator color="orange" size="big" />
						:
						<DocumentViewer
							className={styles.documentPreview}
							data={data!}
						/>
					}
				</CustomModal.Body>
				<CustomModal.Footer>
					<Button
						label="Close"
						onClick={closeModal}
						style="secondary"
					/>
				</CustomModal.Footer>
			</CustomModal>
		</>
	);
});

function mapDispatchToProps() {
	return {
		downloadAttachmentForPreview: AttachmentActions.downloadAttachmentForPreview,
	};
}

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(DocumentPreviewModal);
